import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeParentheses'
})
export class RemoveParenthesesPipe implements PipeTransform {
  transform(value?: string): string {
    return value ? value.trim().replace(/^\s*\(|\)$/g, '') : '';
  }
}
